import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "ionic-angular";
import { ContactControlComponent } from "./contact-control.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormHelperService } from "../../../services/form-helper-service/form-helper.service";
import { ControlMessageModule } from "../../../modules-other/control-message/control-messages.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
        ControlMessageModule
    ],
    declarations: [
        ContactControlComponent
    ],
    exports: [
        ContactControlComponent
    ]
})
export class ContactControlModule {

    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ContactControlModule,
            providers: [
                TranslateService,
                FormHelperService
            ]
        };
    }

}



// WEBPACK FOOTER //
// ./src/vas/controls/contact/form/contact-control.module.ts